/* Safety net for the desktop scroll fix in venro-ui-consistency.css.
   On desktop .page-wrapper is the only scroll container; html/body must stay at 0.
   Anything that still scrolls them (app embeds, browser extensions, scrollIntoView,
   anchor links) is undone immediately. Mobile (document scrolling) is left untouched. */
(() => {
  const wrapper = document.querySelector('.page-wrapper');
  if (!wrapper) return;
  const root = document.documentElement;
  const body = document.body;
  const wrapperScrolls = () => /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY);
  const reset = () => {
    if (!wrapperScrolls()) return;
    if (root.scrollTop || root.scrollLeft) root.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (body.scrollTop || body.scrollLeft) body.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  };
  document.addEventListener('scroll', (event) => {
    if (event.target === document || event.target === root || event.target === body) reset();
  }, { capture: true, passive: true });
  window.addEventListener('hashchange', () => requestAnimationFrame(reset));
  window.addEventListener('pageshow', reset);
  reset();
})();
